/** Times for the trim fields: seconds ⇄ "m:ss.s". */

export const formatTrimTime = sec => {
	const s = Math.max(0, Math.round((sec || 0) * 10) / 10);
	const m = Math.floor(s / 60);
	const rest = (s - m * 60).toFixed(1).padStart(4, '0');
	return `${m}:${rest}`;
};

/** "1:05.5", "65.5" or "1:05" → seconds; null when it is not a time. */
export const parseTrimTime = text => {
	const t = String(text ?? '').trim();
	const m = /^(?:(\d+):)?(\d+(?:[.,]\d+)?)$/.exec(t);
	if (!m) return null;
	const sec = Number(m[2].replace(',', '.'));
	if (m[1] !== undefined && sec >= 60) return null;
	return (m[1] ? Number(m[1]) * 60 : 0) + sec;
};

/** A new start or end, kept inside the clip and at least `minSpan` seconds apart. */
export const clampTrim = (range, which, value, duration, minSpan = 1) => {
	const v = Math.round(Math.max(0, Math.min(duration, value)) * 100) / 100;
	return which === 'start'
		? {
				start_seconds: Math.min(v, range.end_seconds - minSpan),
				end_seconds: range.end_seconds,
			}
		: {
				start_seconds: range.start_seconds,
				end_seconds: Math.max(v, range.start_seconds + minSpan),
			};
};
